var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"xmgl-box"},_vm._l((_vm.listData),function(item,index){return _c('div',{key:index,staticClass:"xmgl-box-item"},[_c('div',{staticClass:"xmgl-box-item-name"},[_vm._v(_vm._s(item.label))]),_c('div',{staticClass:"xmgl-box-item-value"},[_vm._v(_vm._s(_vm.detailsData[item.key] || '--')+_vm._s(item.units))])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }